/*
 * Nord Est — wishlist ("favorite" products)
 * Stores liked products in the visitor's own browser (localStorage), no account needed.
 */
(function () {
  var STORAGE_KEY = 'nordEstWishlist';

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* storage unavailable (private mode, quota) — fail silently */
    }
  }

  function isInWishlist(id) {
    var items = getWishlist();
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].id) === String(id)) return true;
    }
    return false;
  }

  function toggleWishlist(data) {
    var items = getWishlist();
    var index = -1;
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].id) === String(data.id)) {
        index = i;
        break;
      }
    }
    if (index > -1) {
      items.splice(index, 1);
    } else {
      items.push(data);
    }
    saveWishlist(items);
    updateAllButtons();
    document.dispatchEvent(new CustomEvent('nordest:wishlist-updated', { detail: { items: items } }));
  }

  function updateButtonState(btn) {
    var id = btn.getAttribute('data-product-id');
    var active = isInWishlist(id);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = active ? btn.getAttribute('data-label-remove') : btn.getAttribute('data-label-add');
    if (label) btn.setAttribute('aria-label', label);
  }

  function updateAllButtons() {
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) updateButtonState(buttons[i]);

    var count = getWishlist().length;
    var badges = document.querySelectorAll('[data-wishlist-count]');
    for (var j = 0; j < badges.length; j++) {
      badges[j].textContent = count;
      badges[j].hidden = count === 0;
    }
  }

  function handleClick(e) {
    var btn = e.target.closest && e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggleWishlist({
      id: btn.getAttribute('data-product-id'),
      handle: btn.getAttribute('data-product-handle'),
      title: btn.getAttribute('data-product-title'),
      image: btn.getAttribute('data-product-image'),
      price: btn.getAttribute('data-product-price'),
      url: btn.getAttribute('data-product-url'),
    });
  }

  function renderFavoritesPage() {
    var container = document.querySelector('[data-wishlist-page]');
    if (!container) return;
    var items = getWishlist();
    var emptyEl = container.querySelector('[data-wishlist-empty]');
    var gridEl = container.querySelector('[data-wishlist-grid]');
    if (!gridEl) return;

    if (items.length === 0) {
      gridEl.innerHTML = '';
      gridEl.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
      return;
    }

    gridEl.hidden = false;
    if (emptyEl) emptyEl.hidden = true;

    var html = '';
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var title = escapeHtml(item.title);
      var url = escapeHtml(item.url);
      var image = escapeHtml(item.image);
      var price = escapeHtml(item.price);
      html +=
        '<div class="wishlist-card">' +
        '<a href="' +
        url +
        '" class="wishlist-card__media">' +
        (item.image ? '<img src="' + image + '" alt="' + title + '" loading="lazy" width="400" height="400">' : '') +
        '</a>' +
        '<div class="wishlist-card__content">' +
        '<a href="' +
        url +
        '" class="wishlist-card__title">' +
        title +
        '</a>' +
        '<div class="wishlist-card__price">' +
        price +
        '</div>' +
        '<button type="button" class="wishlist-card__remove link" data-wishlist-toggle' +
        ' data-product-id="' +
        escapeHtml(item.id) +
        '"' +
        ' data-product-handle="' +
        escapeHtml(item.handle) +
        '"' +
        ' data-product-title="' +
        title +
        '"' +
        ' data-product-image="' +
        image +
        '"' +
        ' data-product-price="' +
        price +
        '"' +
        ' data-product-url="' +
        url +
        '"' +
        ' data-label-add="Adaugă la favorite" data-label-remove="Elimină din favorite"' +
        ' aria-pressed="true">Elimină din favorite</button>' +
        '</div>' +
        '</div>';
    }
    gridEl.innerHTML = html;
    updateAllButtons();
  }

  document.addEventListener('click', handleClick);
  document.addEventListener('nordest:wishlist-updated', renderFavoritesPage);

  function init() {
    updateAllButtons();
    renderFavoritesPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
